import { Component } from '@angular/core';
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { AbstractEditComponent } from './abstract-edit.component';
import { DialogReturnTypeAction, DialogReturnType } from 'src/app/app.types';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'qa-can-deactivate-dialog',
  templateUrl: './can-deactivate-dialog.component.html',
  styleUrls: ['./can-deactivate-dialog.component.scss'],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class CanDeactivateDialogComponent {
  dialogReturnTypeAction = DialogReturnTypeAction;

  constructor(
    public dialogRef: MatDialogRef<
      AbstractEditComponent,
      DialogReturnType<void>
    >
  ) {}
}
